import { atom } from "jotai";

export const tutorsList=atom([])

